import React, { useState, useContext } from 'react'
import { Link, useNavigate } from 'react-router'
import { Box, Button, withTheme, Icon } from '@mui/material'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import CircleIcon from '@mui/icons-material/Circle'
import { APP_ROUTES } from "../../constants/routes";
import { btnObj2Arr } from "../../helpers/index"
import Generate from './Generate'
import theme from '../../styles/theme'
import AppContext from "../../utils/app-context";
import { isAtLeastMember } from "../../utils/permissions";


const Footbar = (props) => {
  const [fixed, setFixed] = useState(false)
  const navigate = useNavigate();
  const { buttons, generate } = props
  const { state } = useContext(AppContext);
  const genRoute = location.pathname != "/" && location.pathname != APP_ROUTES.STORY_BOARDS && location.pathname.indexOf(APP_ROUTES.PREVIEW) === -1 && location.pathname.indexOf('settings') === -1;
  const styles = {
    position: "fixed",
    width: "calc(100% - 40px)",
    minHeight: "44px",
    zIndex: 999,
    padding: "10px 20px",
    backgroundColor: "var(--bg-footer)",
    borderTop: "1px solid var(--border-subtle)",
    flexDirection: "row",
    bottom: 0,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "var(--shadow-footer)",
    ".left": {
      color: "var(--text-secondary)",
      fontSize: "13px",
      "a": {
        color: "var(--text-primary)",
        fontWeight: 600,
        textDecoration: "underline",
        "&:hover": {
          color: "var(--border-focus)",
        },
      },
    },
    [theme.breakpoints.down('md')]: {
      position: "fixed",
      padding: state.app.isMobileSize ? "10px" : "15px",
      width: state.app.isMobileSize ? "calc(100% - 20px)" : "calc(100% - 30px)",
      //flexDirection: "column-reverse", 
      /*".right" : {
        display: "flex", 
        flexDirection: "column", 
        justifyContent: "end"
      },*/
      button: {
        //margin: "0 0 10px 10px", 
        padding: "6px 12px",
        /*"&:first-of-type": {
          marginLeft: "0"
        }*/
      }
    },
  }
  let btnArr = null;
  if (typeof (buttons) == "Array") {
    btnArr = btnObj2Arr({ buttons: buttons });
  }

  const output = []
  const iconMap = {
    "play": <PlayArrowIcon />,
    "circle": <CircleIcon />
  }
  const clickHandler = () => {
    if (button.href) navigate(button.href)
    else if (button.click) button.click()
  }
  let icon = <></>
  {
    buttons && buttons.map((button, key) => {
      if (button != null) {
        if (button.icon) icon = null //icon = iconMap[button.icon]
        if (button.type == "secondary") {
          output.push(<Button key={key} variant="contained" className="footer-btn" disabled={button.disabled} color="secondary" onClick={() => {
            if (button.href) (button.href)
            else if (button.click) button.click()
          }}>{icon}{button.text}</Button>)
        } else if (button.type == "tertiary") {
          output.push(<Button key={key} variant="outlined" className="footer-btn" disabled={button.disabled} onClick={() => {
            if (button.href) navigate(button.href)
            else if (button.click) button.click()
          }}>{icon}{button.text}</Button>)
        } else {
          output.push(<Button key={key} variant="contained" className="footer-btn" disabled={button.disabled} onClick={() => {
            if (button.href) navigate(button.href)
            else if (button.click) button.click()
          }}>{icon}{button.text}</Button>)
        }
      }
    })
  }

  return <>
    {!genRoute &&
      <Box vertical="true" className="footbar" right sx={styles}>
        <Box className="left">
          Made with <a href="https://gen.10zebra.com/" target="_blank">10zebra</a>.
        </Box>
        <Box className="right">
          {output}
        </Box>
      </Box>
    }
    {genRoute && (state.app.userIsStoryOwner || isAtLeastMember(state.app.userProjectRole) || state.app.settings.communityCanVeneer) &&
      <Generate styles={styles} reimagineItem={generate?.reimagineItem} clearReimagineItem={generate?.clearReimagineItem} regenerateItem={generate?.regenerateItem} clearRegenerateItem={generate?.clearRegenerateItem} shotId={generate?.shotId} selectedShot={generate?.selectedShot || generate?.selectedGenerationShot} selectShotForGeneration={generate?.selectShotForGeneration} showGenerate={generate?.showGenerate} hideGenerate={generate?.hideGenerate} />
    }
    {/*<Box>
      { btnArr || buttons }
    </Box>*/}
  </>
}

export default Footbar